<template>
  <highcharts :options="consumoChart" />
</template>

<script>
import dayjs from 'dayjs';
import { Chart } from 'highcharts-vue';
import { i18n } from '../main';

export default {
  components: {
    highcharts: Chart
  },
  props: {
    options: Array,
    monthly: null,
    name: String
  },
  created() {
    const date = dayjs(this.monthly.mesReferencia).format('MMMM/YYYY');
    this.consumoChart.title.text = `${this.name} Consumo: ${date}`;
    this.consumoChart.xAxis.categories = this.monthly.consumo.consumoHistorico.data;
    this.consumoChart.series[0].data = this.monthly.consumo.consumoHistorico.foraPonta;
    this.consumoChart.series[1].data = this.monthly.consumo.consumoHistorico.ponta;
  },
  data() {
    return {
      consumoChart: {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Valores em MWh'
          },
          labels: {
            formatter: function () {
              return this.value;
            }
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: 'gray'
            },
            format: '{total:.3f}'
          }
        },

        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat:
            '{series.name}: {point.y:.3f}<br/>Total: {point.stackTotal:.3f}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              format: '{point.y:.3f}'
              // enabled: true
            }
          }
        },
        series: [
          {
            name: i18n.tc('chartConsumo.off_the_tip'),
            color: '#004F59',
            data: [],
            tooltip: {
              valueDecimals: 1,
              valueSuffix: ' MWh',
              valuePrefix: ''
            },
            legendIndex: 2
          },
          {
            name: i18n.tc('chartConsumo.tip'),
            color: '#FFCD00',
            data: [],
            tooltip: {
              valueDecimals: 1,
              valueSuffix: ' MWh',
              valuePrefix: '',
              split: true
            },
            legendIndex: 1
          }
        ],
        credits: {
          enabled: false
        }
      }
    };
  }
};
</script>
